/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Etbis_RegisteredInputs */

const tr_legal_footer_etbis_registered = /** @type {(inputs: Legal_Footer_Etbis_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS Kayıtlı · Kayıt No: 4735819565`)
};

const en_legal_footer_etbis_registered = /** @type {(inputs: Legal_Footer_Etbis_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered with ETBİS · Registration number: 4735819565`)
};

const de_legal_footer_etbis_registered = /** @type {(inputs: Legal_Footer_Etbis_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei ETBİS registriert · Registrierungsnummer: 4735819565`)
};

const ru_legal_footer_etbis_registered = /** @type {(inputs: Legal_Footer_Etbis_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрировано в ETBİS · Регистрационный номер: 4735819565`)
};

/**
* | output |
* | --- |
* | "Registered with ETBİS · Registration number: 4735819565" |
*
* @param {Legal_Footer_Etbis_RegisteredInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_etbis_registered = /** @type {((inputs?: Legal_Footer_Etbis_RegisteredInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Etbis_RegisteredInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_etbis_registered(inputs)
	if (locale === "de") return de_legal_footer_etbis_registered(inputs)
	if (locale === "ru") return ru_legal_footer_etbis_registered(inputs)
	return tr_legal_footer_etbis_registered(inputs)
});